export default __webpack_public_path__ + "static/hero-unsplash-0cbb2d1e3ce94ba89140165c5e6badf4.jpg";